import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { JwtPayload } from "jwt-decode";
import Profile from "./components/Profile";
import Register from "./components/Register";
import SidebarLayout from "./components/Sidebar";
import Home from "./components/Home";
import UpdateUserProfile from "./components/UpdateUserProfile";
import AddressMapOne from "./components/AddressList";
import AddNewAddress from "./components/AddNewAddress";
import AddressDetails from "./components/AddressDetails";
import EditAddress from "./components/EditAddress";
import About from "./components/About";
import SignupOtp from "./components/SignUp-Otp";
import Signin from "./components/Signin";
import Signup from "./components/Signup";
import Setting from "./components/Setting";
import Favourites from "./components/Favourite";
import FeedBack from "./components/FeedBack";
import ReportIssue from "./components/ReportIssue";
import Dashboard from "./components/DashBoard";
import ManageUser from "./components/ManageUser";
import ViewFeedBack from "./components/ViewFeedBack";
import ViewReportIssue from "./components/ViewReportIssue";
import UserDetails from "./components/UserDetails";
import FeedbackDetails from "./components/FeedBackDetails";
import ReportIssueDetails from "./components/ReportIssueDetails";
import ViewDeleteRequest from "./components/ViewDeleteRequest";
import DeleteRequestDetails from "./components/DeleteRequestDetails";
// Function to check if the token is expired
const isTokenExpired = (token: string): boolean => {
  try {
    const decoded = jwtDecode<JwtPayload>(token);  // Decode the token
    if (decoded.exp) {
      // Check if the token is expired
      return decoded.exp * 1000 < Date.now();
    }
    return true;  // If token doesn't have an expiry, consider it expired
  } catch (error) {
    console.error('Error decoding token:', error);
    return true;  // If decoding fails, assume the token is expired
  }
};

const App: React.FC = () => {
  const navigate = useNavigate();
  const [userName, setUserName] = useState(localStorage.getItem('userName') || '');

  const updateUserName = (newUserName: string) => {
    setUserName(newUserName);
    localStorage.setItem('userName', newUserName);
  };

  useEffect(() => {
    const token = localStorage.getItem('authToken');
    if (token) {
      if (isTokenExpired(token)) {
        // Token is expired, remove it from localStorage and navigate to login
        localStorage.removeItem('authToken');
        alert('Session expired. Please log in again.');
        navigate('/');
      } else {

      }
    } else {

    }
    const handleEnterKey = (event: KeyboardEvent) => {
      if (event.key === "Enter") {
        const activeElement = document.activeElement;
        // Check if the active element is a text field or textarea
        if (activeElement instanceof HTMLInputElement || activeElement instanceof HTMLTextAreaElement) {
          const submitButton = document.querySelector('button[type="submit"]') as HTMLButtonElement; // Type assertion
          submitButton?.click(); // Trigger click on the submit button
        }
      }
    };
    

    // Add the keydown listener
    document.addEventListener("keydown", handleEnterKey);

    // Clean up the listener on component unmount
    return () => {
      document.removeEventListener("keydown", handleEnterKey);
    };
  }, [navigate]);

  return (
    <Routes>
      <Route path="/" element={<Signin />} />
      <Route path="/register" element={<Register updateUserName={updateUserName} />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/signup-otp" element={<SignupOtp />} />

      <Route element={<SidebarLayout />}>
        <Route path="/home" element={<Home updateUserName={updateUserName} />} />
        <Route path="/profile" element={<Profile updateUserName={updateUserName} />} />
        <Route path="/addressmapone" element={<AddressMapOne updateUserName={updateUserName} />} />
        <Route path="/favourites" element={<Favourites updateUserName={updateUserName} />} />
        <Route path="/about" element={<About updateUserName={updateUserName} />} />
        <Route path="/setting" element={<Setting updateUserName={updateUserName} />} />
        <Route path="/add-new-address" element={<AddNewAddress updateUserName={updateUserName} />} />
        <Route path="/address-details/:id" element={<AddressDetails />} />
        <Route path="/edit-address/:id" element={<EditAddress />} />
        <Route path="/update-user-profile" element={<UpdateUserProfile updateUserName={updateUserName} />} />      
        <Route path="/feedback" element={<FeedBack updateUserName={updateUserName}/>}/>
        <Route path="/report-issue" element={<ReportIssue updateUserName={updateUserName}/>}/>
        
        <Route path="/DashBoard" element={<Dashboard/>}/>
        <Route path="/ManageUser" element={<ManageUser/>}/>
        <Route path="/ViewFeedback" element={<ViewFeedBack/>}/>
        <Route path="/ViewReportIssue" element={<ViewReportIssue/>}/>
        <Route path="/user-details/:userId" element={<UserDetails />} />
        <Route path="/feedback-details/:index" element={<FeedbackDetails/>} />
        <Route path="/report-issue-details/:index" element={<ReportIssueDetails/>} />
        <Route path="/view-delete-request/" element={<ViewDeleteRequest/>}/>
        <Route path="/delete-request-details/:index" element={<DeleteRequestDetails />} />
            </Route>
    </Routes>
  );
};

// Wrap the app with BrowserRouter in the main entry point (index.tsx or App.tsx)

const Root: React.FC = () => {
  return (
    <Router> 
      <App />
    </Router>
  );
};

export default Root;
